import React from 'react'
import styled from 'styled-components';
import { Zoom } from 'react-awesome-reveal';

import skinstorePic from '../Images/skinstorePic.png'
import hotstar from '../Images/hotstar.png';
import expedia from '../Images/expedia.png';
import tic from '../Images/tic-tac-toe.png.webp'
import CardDiv from './CardDiv';
import { Flex, Grid, SimpleGrid } from '@chakra-ui/react';

const Projects = () => {
    let data = [
        {
          title:'Skinstore-clone',
            img : skinstorePic,
            techstack:['HTML','CSS','Javascript','Local Storage'],
            disc : "🌟  A reimagined front-end of the leading online destination for premium beauty products, featuring over 8000 products across 300+ brands.",
            deployed:"https://skinstore-clone-nine.vercel.app/",
            github:"https://github.com/saintlypioneer/skinstore-clone"
          },
          {
            title:'Hotstar-clone',
            img : hotstar,
            techstack:['React','Redux','ChakraUI','HTML','CSS'],
            disc : "Ann Indian subscription video on-demand over-the-top streaming service platform.",
            deployed:"https://hotstart-clone.vercel.app/",
            github:"https://github.com/Vishalll069/Hotstar-Clone"
          },
          {
            title:'Expedia-clone',
            img : expedia,
            techstack:['HTML','CSS','Javascript','Bootstrap'],
            disc : " An online travel agency that can be used to book airline tickets, hotel reservations, car rentals, cruise ships, and vacation packages.",
            deployed:"https://effulgent-crostata-f624a5.netlify.app/",
            github:"https://github.com/seakash1204/expedia_clone"
          },
    
          {
            title:'Tic-Tac-Toe',
            img : tic,
            techstack:['HTML','CSS','Javascript','Bootstrap'],
            disc:"A simple game of tic-tac-toe , have fun playing it.",
            deployed:"https://i2.paste.pics/f576d000457fe55f50f5e45f1525f59e.png",
            github:"https://github.com/shailezb7/tic-tac-toe/tree/main/game"
          }
    ];
  return (
    <Container id='projects' color='white' >
        <Zoom>
            <h1 style={{color:"white"}}>Recent <span className="green">Projects</span></h1>
        
        </Zoom>
        {/* <Slide>
            <SliderComp/>
        </Slide> */}
         {
             <SimpleGrid columns={[1,2,2]} gap={'20px'} >
               
             {  data.map((e,i)=>{
                  return <CardDiv e={e} key={i}/>
               })
            }

            </SimpleGrid>
         }
    </Container>
  )
}

export default Projects;

const Container = styled.div`
    width: 80%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 3rem 0;
    text-align: center;
    position: relative;
    @media(max-width: 840px){
        width: 90%;
    }
    h1{
        font-size: 1.9rem;
    }

    p{
        width: 28rem;
        margin: 0 auto;
        padding: 1rem 0;
        font-size: 0.9rem;
        @media(max-width : 500px){
            width: 90%;
        }
    }
    
`

const Slide = styled.div``